import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IIndustryParams, IIndustryItem, ITradeDetail, ITradeInfo, ITradeInvoice } from '../../../../types/system/base/industry';

const hostUrl = getHostbaseUrl();

/**
 * 获取行业分页列表
 * @param params 分页参数
 */
export async function getIndustryPage(params: IIndustryParams) {
  try {
    const { code, context, message } = await Http.post<{ data: IIndustryItem[]; total: number }>(
      `${hostUrl}/side/sys/trade/page`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || {
        data: [],
        total: 0,
      };
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 新增行业
 * @param params 行业信息
 */
export async function addIndustryApi(params: IIndustryItem) {
  try {
    const { code, message } = await Http.post(`${hostUrl}/side/sys/trade/add`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 修改行业
 * @param params 行业信息
 */
export async function updateIndustry(params: IIndustryItem) {
  try {
    const { code, message } = await Http.post(`${hostUrl}/side/sys/trade/update`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查询行业列表
 * @param params 查询参数
 * @returns 行业列表数据
 */
export async function queryTradeList() {
  try {
    const { code, context, message } = await Http.post<ITradeDetail[]>(
      `${hostUrl}/side/sys/trade/list`,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 查看开票科目明细
 * @param id 查询参数
 * @returns 行业列表数据
 */
export async function queryTradeDetail(id: number) {
  let data = {} as ITradeInfo;

  try {
    const { code, context, message } = await Http.get<ITradeInfo>(
      `${hostUrl}/side/sys/trade/detail`,
      { id },
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || data;
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 行业-批量配置开票科目
 * @param params 参数
 */
export async function TradeConfigInvoiceSub(params: ITradeInvoice) {
  try {
    const { code, context, message } = await Http.post(
      `${hostUrl}/side/sys/trade/config/invoiceSub`,
      params,
    );

    if (code === EAxiosResponseCode.Succeed) {
      return context || {};
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}
